import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetContainerTypeFacetsAdminQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetContainerTypeFacetsAdminQuery = { __typename?: 'Query', getContainerTypeFacetsAdmin: { __typename?: 'AdminContainerTypeFacets', sizes: Array<string>, brandings: Array<string>, legal_owners: Array<string>, max_order_key: number, max_id: number, total_count: number } };


export const GetContainerTypeFacetsAdminDocument = gql`
    query GetContainerTypeFacetsAdmin {
  getContainerTypeFacetsAdmin {
    sizes
    brandings
    legal_owners
    max_order_key
    max_id
    total_count
  }
}
    `;

/**
 * __useGetContainerTypeFacetsAdminQuery__
 *
 * To run a query within a React component, call `useGetContainerTypeFacetsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContainerTypeFacetsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContainerTypeFacetsAdminQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContainerTypeFacetsAdminQuery(baseOptions?: Apollo.QueryHookOptions<GetContainerTypeFacetsAdminQuery, GetContainerTypeFacetsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContainerTypeFacetsAdminQuery, GetContainerTypeFacetsAdminQueryVariables>(GetContainerTypeFacetsAdminDocument, options);
      }
export function useGetContainerTypeFacetsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContainerTypeFacetsAdminQuery, GetContainerTypeFacetsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContainerTypeFacetsAdminQuery, GetContainerTypeFacetsAdminQueryVariables>(GetContainerTypeFacetsAdminDocument, options);
        }
export type GetContainerTypeFacetsAdminQueryHookResult = ReturnType<typeof useGetContainerTypeFacetsAdminQuery>;
export type GetContainerTypeFacetsAdminLazyQueryHookResult = ReturnType<typeof useGetContainerTypeFacetsAdminLazyQuery>;
export type GetContainerTypeFacetsAdminQueryResult = Apollo.QueryResult<GetContainerTypeFacetsAdminQuery, GetContainerTypeFacetsAdminQueryVariables>;